export const colorsRBG = [
  [32, 142, 183],
  [0, 255, 255],
  [44, 192, 161],
  [227, 19, 238],
  [193, 133, 27],
  [131, 188, 33],
  [214, 120, 239],
  [48, 79, 155],
  [193, 134, 230],
  [249, 121, 48],
  [73, 104, 3],
  [253, 4, 143],
  [26, 167, 238],
  [14, 198, 28],
  [100, 176, 48],
  [157, 178, 134],
  [143, 53, 169],
  [5, 110, 18],
  [188, 28, 250],
  [242, 197, 124],
  [168, 162, 244],
  [53, 89, 82],
  [247, 147, 2],
  [84, 71, 147],
  [237, 75, 4],
  [47, 67, 246],
  [175, 48, 7],
  [59, 193, 133],
  [181, 65, 100],
  [66, 106, 90],
  [115, 70, 75],
  [106, 69, 194],
  [174, 135, 136],
  [253, 137, 146],
  [125, 68, 0]
];
